import {Component, Input, Output, EventEmitter, AfterContentInit, OnDestroy} from '@angular/core';
import { FormControl } from '@angular/forms';
import {Utils} from '../utils';
@Component({
    selector: 'slideWordCount-component',
    templateUrl: 'slideWordCount.component.html'
})
export class SlideWordCountComponent implements AfterContentInit, OnDestroy {
    control = new FormControl();
    options = [50, 100, 200];
    inputRand = this.utils.rand();
    subscription;

    @Input() canEdit;
    @Input() value;
    @Output() valueChange = new EventEmitter();

    constructor(private utils: Utils) {
        this.subscription = this.control.valueChanges.subscribe(value => {
            this.value = value;
            this.valueChange.emit(this.value);
        });
    }
    ngAfterContentInit() {
        this.control.setValue(this.value);
    }
    ngOnDestroy() {
        if( this.subscription ) {
            this.subscription.unsubscribe();
        }
    }
    
}